import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import Steper from "Component/Steper/Steper";
import Selecttokenmod from "Component/Modals/Selecttokenmod";

import { Link, useNavigate } from "react-router-dom";
import useToastr from "helpers/toastr";

const Defiswapconnect = () => {
  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  const toastr = useToastr();

  const handleback = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <Fade>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />

      <section className="home_banner_main buy_page position-relative">
        <div className="top_circle"></div>

        <Container className="position-relative container_postition">
          <Row>
            <Col lg={4} md={6} sm={12} className="m-auto">
              <h2 className="defi_head text-start ps-lg-2 mb-3">
                <span>DeFi Swap</span> Crypto
              </h2>
              <div className="defi_white_box text-start mx-lg-2">
                <Form>
                  <div className="d-flex justify-content-end align-items-center gap-2">
                    <p className="m-0">Connect Wallet</p>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M3.99967 13.3333C3.26634 13.3333 2.63856 13.0722 2.11634 12.55C1.59412 12.0277 1.33301 11.4 1.33301 10.6666V5.33329C1.33301 4.59996 1.59412 3.97218 2.11634 3.44996C2.63856 2.92774 3.26634 2.66663 3.99967 2.66663H11.9997C12.733 2.66663 13.3608 2.92774 13.883 3.44996C14.4052 3.97218 14.6663 4.59996 14.6663 5.33329V10.6666C14.6663 11.4 14.4052 12.0277 13.883 12.55C13.3608 13.0722 12.733 13.3333 11.9997 13.3333H3.99967ZM3.99967 5.33329H11.9997C12.2441 5.33329 12.4775 5.36107 12.6997 5.41663C12.9219 5.47218 13.133 5.56107 13.333 5.68329V5.33329C13.333 4.96663 13.2023 4.65263 12.941 4.39129C12.6797 4.12996 12.3659 3.99951 11.9997 3.99996H3.99967C3.63301 3.99996 3.31901 4.13063 3.05767 4.39196C2.79634 4.65329 2.6659 4.96707 2.66634 5.33329V5.68329C2.86634 5.56107 3.07745 5.47218 3.29967 5.41663C3.5219 5.36107 3.75523 5.33329 3.99967 5.33329ZM2.76634 7.49996L10.183 9.29996C10.283 9.32218 10.383 9.32218 10.483 9.29996C10.583 9.27774 10.6775 9.23329 10.7663 9.16663L13.083 7.23329C12.9608 7.06663 12.8052 6.9304 12.6163 6.82463C12.4275 6.71885 12.2219 6.66618 11.9997 6.66663H3.99967C3.71079 6.66663 3.45812 6.74174 3.24167 6.89196C3.02523 7.04218 2.86679 7.24485 2.76634 7.49996Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>

                  <div className="connect_heading_col text-center position-relative border-bottom pb-2 mt-4">
                    <Link to="" onClick={handleback} className="connect_back">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M5 12H19M5 12L11 18M5 12L11 6"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Link>
                    <h4>Select Your Wallet</h4>
                  </div>

                  <div className="connection_wallet mt-4">

                    <ul className="m-0">
                      <li>
                      <Link to="" className="d-flex align-items-center gap-3">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="21"
                          viewBox="0 0 22 21"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_144_3876)">
                            <path
                              d="M21.4903 0L12.0503 6.98491L13.8057 2.86851L21.4903 0Z"
                              fill="#E17726"
                            />
                            <path
                              d="M0.531996 0.00823975L8.19599 2.86901L9.86283 7.03939L0.531996 0.00823975ZM17.6911 14.855L21.8634 14.9344L20.4052 19.888L15.314 18.4863L17.6911 14.855ZM4.30878 14.855L6.67696 18.4863L1.59436 19.8881L0.14502 14.9344L4.30878 14.855Z"
                              fill="#E27625"
                            />
                            <path
                              d="M9.63628 5.97713L9.80679 11.4843L4.70459 11.2521L6.1559 9.06263L6.17429 9.04157L9.63628 5.97713ZM12.3109 5.91568L15.8258 9.04174L15.844 9.06271L17.2953 11.2522L12.1942 11.4843L12.3109 5.91568ZM6.82647 14.871L9.61239 17.0417L6.37616 18.6041L6.82647 14.871ZM15.1741 14.8706L15.615 18.6042L12.3878 17.0415L15.1741 14.8706Z"
                              fill="#E27625"
                            />
                            <path
                              d="M12.4592 16.837L15.734 18.4228L12.6878 19.8705L12.7194 18.9136L12.4592 16.837ZM9.54014 16.8377L9.29014 18.898L9.31068 19.8693L6.25732 18.4228L9.54014 16.8377Z"
                              fill="#D5BFB2"
                            />
                            <path
                              d="M8.5944 12.203L9.45016 14.0015L6.53662 13.148L8.5944 12.203ZM13.4056 12.2032L15.4731 13.148L12.55 14.0013L13.4056 12.2032Z"
                              fill="#233447"
                            />
                            <path
                              d="M7.04889 14.8526L6.57795 18.7232L4.05371 14.9372L7.04889 14.8526ZM14.9508 14.8527L17.9461 14.9372L15.4124 18.7234L14.9508 14.8527ZM17.3688 11.0333L15.189 13.2548L13.5083 12.4868L12.7037 14.1784L12.1762 11.2695L17.3688 11.0333ZM4.62966 11.0333L9.8233 11.2695L9.29573 14.1784L8.49092 12.4871L6.81918 13.2549L4.62966 11.0333Z"
                              fill="#CC6228"
                            />
                            <path
                              d="M4.48291 10.5773L6.94914 13.0799L7.03457 15.5505L4.48291 10.5773ZM17.5194 10.5729L14.9631 15.5549L15.0593 13.0799L17.5194 10.5729ZM9.70284 10.7298L9.8021 11.3546L10.0474 12.911L9.88967 17.6913L9.14416 13.8511L9.1439 13.8114L9.70284 10.7298ZM12.2957 10.7211L12.8561 13.8114L12.8558 13.8511L12.1084 17.7009L12.0788 16.7379L11.9622 12.8826L12.2957 10.7211Z"
                              fill="#E27525"
                            />
                            <path
                              d="M15.2788 12.9805L15.1953 15.1271L12.5936 17.1541L12.0677 16.7825L12.6572 13.7459L15.2788 12.9805ZM6.73047 12.9805L9.34288 13.7459L9.93241 16.7825L9.40648 17.1541L6.80472 15.1269L6.73047 12.9805Z"
                              fill="#F5841F"
                            />
                            <path
                              d="M5.75928 17.9487L9.08781 19.5259L9.07371 18.8524L9.35224 18.6079H12.6466L12.9351 18.8515L12.9138 19.5245L16.2213 17.9527L14.6119 19.2827L12.6658 20.6192H9.32551L7.38075 19.2772L5.75928 17.9487Z"
                              fill="#C0AC9D"
                            />
                            <path
                              d="M12.2204 16.6271L12.691 16.9596L12.9668 19.1599L12.5677 18.823H9.43304L9.0415 19.1667L9.30825 16.9598L9.77902 16.6271H12.2204Z"
                              fill="#161616"
                            />
                            <path
                              d="M20.8668 0.193359L22 3.59279L21.2923 7.03003L21.7962 7.41873L21.1143 7.93899L21.6269 8.33482L20.9482 8.9528L21.3648 9.25452L20.2592 10.5458L15.7242 9.22539L15.685 9.20434L12.417 6.44763L20.8668 0.193359ZM1.13317 0.193359L9.58306 6.44763L6.31503 9.20434L6.27576 9.22539L1.74084 10.5458L0.635164 9.25452L1.05145 8.95305L0.373227 8.33482L0.884727 7.93942L0.192586 7.4177L0.715516 7.02874L0 3.59296L1.13317 0.193359Z"
                              fill="#763E1A"
                            />
                            <path
                              d="M15.5024 8.93663L20.3074 10.3356L21.8685 15.1469H17.75L14.9124 15.1827L16.9761 11.1601L15.5024 8.93663ZM6.49754 8.93663L5.02362 11.1601L7.08758 15.1827L4.25121 15.1469H0.140137L1.69243 10.3357L6.49754 8.93663ZM14.0408 2.84555L12.6968 6.47546L12.4116 11.3791L12.3024 12.9161L12.2938 16.8424H9.7061L9.69768 12.9234L9.58819 11.3778L9.30288 6.47546L7.95907 2.84555H14.0408Z"
                              fill="#F5841F"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_144_3876">
                              <rect width="22" height="20.625" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      MetaMask
                    </Link>
                      </li>

                      <li>
                      <Link to="" className="d-flex align-items-center gap-3">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11 0C17.0758 0 22 4.92422 22 11C22 17.0758 17.0758 22 11 22C4.92422 22 0 17.0758 0 11C0 4.92422 4.92422 0 11 0Z"
                            fill="url(#paint0_radial_144_3894)"
                          />
                          <path
                            d="M6.99121 8.49493C9.2041 6.3336 12.7963 6.3336 15.0092 8.49493L15.2756 8.75704C15.3873 8.86446 15.3873 9.04063 15.2756 9.14805L14.3646 10.0375C14.3088 10.0934 14.2186 10.0934 14.1627 10.0375L13.7975 9.68087C12.2506 8.17266 9.7498 8.17266 8.20293 9.68087L7.81191 10.0633C7.75605 10.1191 7.66582 10.1191 7.60996 10.0633L6.69902 9.17383C6.5873 9.06641 6.5873 8.89024 6.69902 8.78282L6.99121 8.49493ZM16.8955 10.334L17.7076 11.1246C17.8193 11.232 17.8193 11.4082 17.7076 11.5156L14.051 15.0863C13.9393 15.1938 13.7588 15.1938 13.6514 15.0863L11.0561 12.5512C11.0303 12.5254 10.983 12.5254 10.9572 12.5512L8.36191 15.0863C8.2502 15.1938 8.06973 15.1938 7.9623 15.0863L4.29277 11.5156C4.18105 11.4082 4.18105 11.232 4.29277 11.1246L5.10488 10.334C5.2166 10.2266 5.39707 10.2266 5.50449 10.334L8.0998 12.8691C8.12559 12.8949 8.17285 12.8949 8.19863 12.8691L10.7939 10.334C10.9057 10.2266 11.0861 10.2266 11.1936 10.334L13.7889 12.8691C13.8146 12.8949 13.8619 12.8949 13.8877 12.8691L16.483 10.334C16.6033 10.2266 16.7838 10.2266 16.8955 10.334Z"
                            fill="white"
                          />
                          <defs>
                            <radialGradient
                              id="paint0_radial_144_3894"
                              cx="0"
                              cy="0"
                              r="1"
                              gradientUnits="userSpaceOnUse"
                              gradientTransform="translate(6.81877e-05 11.0003) scale(22)"
                            >
                              <stop stop-color="#5D9DF6" />
                              <stop offset="1" stop-color="#006FFF" />
                            </radialGradient>
                          </defs>
                        </svg>
                      </span>
                      Wallet Connect
                    </Link>

                      </li>
                    </ul>
                  

                    
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Defiswapconnect;
